import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=3b0ddc51&scoped=true"
import script from "./Marcas.vue?vue&type=script&lang=js"
export * from "./Marcas.vue?vue&type=script&lang=js"
import style0 from "./Marcas.vue?vue&type=style&index=0&id=3b0ddc51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ddc51",
  null
  
)

export default component.exports